import CustomizeDataEditorPropertyLabel from "./CustomizeDataEditorPropertyLabel";

export default CustomizeDataEditorPropertyLabel;
export { CustomizeDataEditorPropertyLabel };
